import ozCardListing from '@/components/oz-card/oz-card-listing'
import ozCardDynamic from '@/components/oz-card/oz-card-dynamic/'
import { ENUM_TYPE_CARDS, TYPE_LISTING } from '@/utils/constants/results'

export default {
  name: 'oz-cards-container',

  props: {
    listing: { type: Object },
    pagination: { type: Object },
    position: { type: Number },
    businessTypeContext: { type: String },
    mapPopupId: { type: String },
    shouldRenderAsLink: { type: Boolean },
    shouldRender: { type: Boolean, default: true },
    shouldRenderDynamicTitle: { type: Boolean, default: false },
    shouldRenderWithoutDescription: { type: Boolean, default: false },
    isLeadPhoneModalVariation: { type: Boolean },
  },

  computed: {
    isDevelopmentsListing () {
      return this.listing.type === TYPE_LISTING.developments
    },

    isSuperPremiumListing () {
      return this.listing.type === TYPE_LISTING.superPremium
    },

    preLoadFirstImg () {
      return this.position < 2
    },

    isMapSelected () {
      return this.listing.listing.id === this.mapPopupId
    },

    getTypeCard () {
      const {
        shouldRenderDynamicTitle, shouldRenderWithoutDescription,
      } = this

      const {
        defaultLayout, dynamic,
      } = ENUM_TYPE_CARDS

      const returnObj = (layout, typeProps) => ({ layout, typeProps })

      if (shouldRenderDynamicTitle) {
        return returnObj(dynamic, { shouldRenderWithoutDescription })
      }

      return returnObj(defaultLayout, {})
    },
  },

  methods: {
    handleCardLayout (selectTemplate, props) {
      const {
        defaultLayout, dynamic,
      } = ENUM_TYPE_CARDS

      const templates = {
        [defaultLayout]: () => <oz-card-listing {...props}/>,
        [dynamic]: () => <oz-card-dynamic {...props}/>,
      }

      return templates[selectTemplate]()
    },

    mountPropsCard (propsByLayout) {
      const {
        listing, position, businessTypeContext, shouldRenderAsLink,
      } = this

      return {
        props: {
          index: position,
          preloadFirstImg: this.preLoadFirstImg,
          listing: listing.listing,
          link: listing.link,
          dataId: listing.listing.id,
          rootListing: listing,
          listingType: listing.type,
          account: listing.account,
          url: listing.link.href,
          businessTypeContext,
          selected: this.isMapSelected,
          key: listing.id,
          ref: `listing_${listing.listing.id}`,
          shouldRenderAsLink,
          isLeadPhoneModalVariation: this.isLeadPhoneModalVariation,
          ...propsByLayout,
        },
      }
    },
  },

  render () {
    if (!this.shouldRender) return ''

    const { layout, typeProps } = this.getTypeCard
    const props = this.mountPropsCard(typeProps)
    return this.handleCardLayout(layout, props)
  },

  components: {
    ozCardListing,
    ozCardDynamic,
  },
}
